import React from "react";
import { F } from "../_shared";

export default function StepDates({ q, setQ }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <F label="Start Date" type="date" value={q.start_date} onChange={(v)=>setQ((p)=>({...p, start_date: v}))} testid="tour-start" />
        <F label="End Date (auto)" type="date" value={q.end_date} onChange={(v)=>setQ((p)=>({...p, end_date: v}))} testid="tour-end" />
      </div>
      <p className="text-xs text-slate-500 mt-3">End date is calculated from start date + total nights. Edit if needed.</p>
    </>
  );
}
